import React from 'react';
import { CircularProgress } from '@tempmee/react';

/**
 * The app's loading indicator — the design system's spinning ring, at the
 * design system's spinner size.
 *
 * It deliberately imposes no layout of its own. Callers use it two ways: as a
 * whole-page placeholder (`if (loading) return <Spinner />`) and inline beside
 * a heading while refetching (see CustomTable). Giving it a wrapper tall
 * enough to centre the first case turns the second into a 400px flex item that
 * shoves the heading down the page and snaps it back on load. Callers that
 * want it centred position it themselves.
 */
export const Spinner = () => <CircularProgress size={32} />;

export default Spinner;
